import React, { useEffect, useState } from 'react';
import {
    FormControl, Grid, Paper,
    useMediaQuery, Button, Table, TableBody, TableCell, TableContainer,
    TableRow, FormLabel, RadioGroup, FormControlLabel, Radio,
    CircularProgress

} from '@mui/material';
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import styled, { inputStyles } from '../../Utils/inputChanges';
import { useDispatch, useSelector } from 'react-redux';
import { errorStyles } from '../../Utils/table';
import { fetchStitchReturnGrpStid } from '../../Store/PHPSlice/Stitching/StitchApi';
import { selectPressInwRegById, selectStitchReGrpStId, selectStkBarcode, selectStkInwMemos, selectStockMemoNo } from '../Selectors/StitchSelector/StitchingSelectors';
import { getCurrentDate } from '../../Utils/Dateutils';
import TitleBar from '../TitleBar';
import { StockMenu } from '../TitleList';
import { fetchDepartmentData } from '../../Store/PHPSlice/Department';
import { selectDaparement } from '../Selectors/Master/MasterSelectors';
import { fetchContractorReGrplist2 } from '../../Store/PHPSlice/Cutting/cuttingApi';
import { selectContReGrplist2, selectlocationdata, selectRack } from '../Selectors/Master/ItemSelectors';
import { fetchStkInwMemos, fetchStkReturnBarcode, fetchStockMemoNo, insertStockEntryProduction } from '../../Store/PHPSlice/Stock/StockApis';
import Dropdown from '../FieldsComponents/Dropdown';
import DateInputComponent from '../FieldsComponents/DateInputComponent';
import axios from 'axios';
import { fetchRackData } from '../../Store/PHPSlice/Rack';
import { fetchLocationData } from '../../Store/PHPSlice/Transport';
import { fetchPressInwRegByPrId } from '../../Store/PHPSlice/Press/PressingApi';


const StkProdEntry2 = () => {
    const userdata = JSON.parse(localStorage.getItem('user'));
    const baseUrl = process.env.REACT_APP_BASE_URL;
    const [formData, setFormData] = useState({
        dt: getCurrentDate(),
        stkMemo: '',
        ordType: '0',
        departNm: '',
        departId: '',
        streId: '',
        cutreId: '0',
        stchtopk: '',
        item: '',
        itemId: '',
        icode: '',
        empNm: '',
        empId: '',
        mcloth: '',
        m1cloth: '',
        m2cloth: '',
        m3cloth: '',
        m1clothNm: '',
        m2clothNm: '',
        m3clothNm: '',
        soId: '',
        sono: '',
        totQty: '',
        instructions: '',
        clothNm: '',
        model: '',
        shadeNo: '',
        color: '',
        userId: userdata?.ID
    });
    const [infoData, setInfoData] = useState([]);
    const [rbqty, setRbqty] = useState([]);
    const [color, setColor] = useState([]);
    const [itemlist, setItemlist] = useState([]);

    const [loading, setLoading] = useState(false);

    const dispatch = useDispatch();
    const departlist = useSelector(selectDaparement);
    const stkmemo = useSelector(selectStockMemoNo);

    const allMemos = useSelector(selectStkInwMemos);
    const StitchingReturnInfo = useSelector(selectStitchReGrpStId);
    const CutToPackInfo = useSelector(selectContReGrplist2);
    const stkbarcode = useSelector(selectStkBarcode);
    const racklist = useSelector(selectRack);
    const loclist = useSelector(selectlocationdata);

    const prlist = useSelector(selectPressInwRegById);
    // console.log(prlist);
    useEffect(() => {
        dispatch(fetchDepartmentData());
        dispatch(fetchStockMemoNo());
        dispatch(fetchStkInwMemos());
        dispatch(fetchStkReturnBarcode());
        dispatch(fetchRackData());
        dispatch(fetchLocationData());
    }, [dispatch]);

    useEffect(() => {
        if (stkmemo?.data) {
            const item = stkmemo?.data?.stkMemo;
            setFormData(prev => ({
                ...prev,
                stkMemo: item
            }));
        }
    }, [stkmemo]);

    //Stitching & stitching to Pack
    useEffect(() => {
        if (StitchingReturnInfo?.Info?.length > 0) {
            const data = StitchingReturnInfo.Info.flatMap(subArray => {
                return subArray.map(obj => obj);
            });

            const info_data = consolidateData(data);
            setInfoData(info_data);

        }
    }, [StitchingReturnInfo]);


    useEffect(() => {
        if (prlist?.info?.length > 0) {
            const data = prlist?.info?.map(it => it.inw_info);

            const flatdata = data?.flatMap(subArray => {
                return subArray.map(obj => obj);
            });
            // console.log(flatdata);
            const consolidata = consolidateData(flatdata);
            setInfoData(consolidata);
        }

        if (prlist?.data) {
            const item = prlist?.data;
            setFormData(prev => ({
                ...prev,
                itemId: item.itemId,
                item: item.itemNm,
                mcloth: item.mcloth,
                m1cloth: item.m1cloth,
                m2cloth: item.m2cloth,
                m3cloth: item.m3cloth,
                m1clothNm: item.m1clothNm,
                m2clothNm: item.m2clothNm,
                m3clothNm: item.m3clothNm,
                clothNm: item.mclothNm,
                icode: item.icode
            }));
        }
    }, [prlist])

    // console.log(StitchingReturnInfo)   

    useEffect(() => {
        if (StitchingReturnInfo && StitchingReturnInfo?.data && StitchingReturnInfo.data.length > 0) {
            const item = StitchingReturnInfo?.data[0];
            setFormData(prev => ({
                ...prev,
                empId: item.empId,
                empNm: item.empNm,
                itemId: item.itemId,
                item: item.itemNm,
                mcloth: item.mcloth,
                m1cloth: item.m1cloth,
                m2cloth: item.m2cloth,
                m3cloth: item.m3cloth,
                m1clothNm: item.m1clothNm,
                m2clothNm: item.m2clothNm,
                m3clothNm: item.m3clothNm,
                clothNm: item.mclothNm,
                model: item.model,
                color: item.mColor,
                shadeNo: item.shadeNo,
                icode: item.icode
            }));
        }
    }, [StitchingReturnInfo]);

    //Cutting To pack
    useEffect(() => {
        if (CutToPackInfo?.returnInfo?.length > 0) {
            const data2 = CutToPackInfo?.returnInfo?.flatMap(subArray => {
                return subArray.map(obj => obj);
            });

            const info_data = consolidateData(data2);
            setInfoData(info_data);
        }
    }, [CutToPackInfo]);

    useEffect(() => {
        if (CutToPackInfo && CutToPackInfo?.data && CutToPackInfo.data.length > 0) {
            const item = CutToPackInfo.data[0];
            setFormData(prev => ({
                ...prev,
                empId: item.empId,
                empNm: item.empNm,
                itemId: item.itemId,
                item: item.itemNm,
                mcloth: item.mcloth,
                m1cloth: item.m1cloth,
                m2cloth: item.m2cloth,
                m3cloth: item.m3cloth,
                m1clothNm: item.m1clothNm,
                m2clothNm: item.m2clothNm,
                m3clothNm: item.m3clothNm,
                clothNm: item.mclothNm,
                model: item.model,
                color: item.mColor,
                shadeNo: item.shadeNo,
                icode: item.icode
            }));
        }
    }, [CutToPackInfo]);

    const isDesktop = useMediaQuery('(min-width:768px)'); // Adjust the breakpoint as per your requirement
    // For filteredDepart:
    const filteredDepart = (departlist?.data && Array.isArray(departlist.data) && departlist?.data?.length > 0)
        ? departlist?.data?.filter(item => item.departNm === 'CUT-TO-PACK' || item.departNm === 'STITCH-TO-PACK' || item.departNm === 'STITCHING' || item.departNm === 'PRESS')
        : [];

    function consolidateData(data) {
        let barcode = parseFloat(stkbarcode?.data?.barcode);

        return data.reduce((acc, curr) => {
            // Find if the size already exists in the accumulator
            const existing = acc.find(item => item.size === curr.size);

            if (existing) {
                // If it exists, sum up the numeric values
                // existing.rqty += Number(curr.rqty);
                existing.dqty += Number(curr.dqty);
                existing.rbqty += Number(curr.rbqty);
            } else {
                // If no exact match, check for any existing object
                const previous = acc[acc.length - 1]; // Get the last added object
                const newObject = previous
                    ? {
                        ...previous, // Clone the previous object
                        size: curr.size, // Update size with current size
                        // rqty: Number(curr.rqty),
                        dqty: Number(curr.dqty),
                        rbqty: Number(curr.rbqty),
                        barcode: barcode++
                    }
                    : {
                        // If no previous object, create a new one
                        size: curr.size,
                        // issqty: curr.issqty,
                        // rqty: Number(curr.rqty),
                        dqty: Number(curr.dqty),
                        rbqty: Number(curr.rbqty),
                        barcode: barcode++
                    };

                acc.push(newObject);
            }

            return acc;
        }, []);
    }

    const handleDateChange = (e) => {
        setFormData({
            ...formData,
            dt: e.target.value
        });
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value.toUpperCase()
        });
    };

    const handleDropdownChange = (e, dropdownType) => {
        const { value } = e.target;
        setFormData({
            ...formData,
            [dropdownType]: value
        });
        switch (dropdownType) {
            case 'streId':
                if (value) {
                    dispatch(fetchStitchReturnGrpStid(value));
                } else if (value === '') {
                    setInfoData([]);
                }
                break;
            case 'cutreId':
                if (value) {
                    dispatch(fetchContractorReGrplist2(value));
                } else {
                    setInfoData([]);
                }
                break;
            case 'stchtopk':
                if (value) {
                    dispatch(fetchStitchReturnGrpStid(value));
                } else {
                    setInfoData([]);
                }
                break;
            case 'prId':
                if (value) {
                    dispatch(fetchPressInwRegByPrId(value));
                } else {
                    setInfoData([]);
                }
                break;
            case 'soId':
                if (value) {

                    if (formData.departNm === '13') {
                        const selectSoId = allMemos?.sonoStitch?.find(item => item.ID === value);
                        const soId = selectSoId?.soId;
                        const memo = selectSoId?.stMemo;
                        const data = {
                            empType: '1',
                            soId: soId,
                            memo: memo
                        };
                        fetchStitchingItems(data);
                        setFormData(prev => ({ ...prev, sono: soId }));
                    } else if (formData.departNm === '12') {
                        const selectSoId = allMemos?.sonoStCont?.find(item => item.ID === value);
                        const soId = selectSoId?.soId;
                        const memo = selectSoId?.stMemo;
                        const data = {
                            empType: '2',
                            soId: soId,
                            memo: memo
                        };

                        fetchStitchingItems(data);
                        setFormData(prev => ({ ...prev, sono: soId }));
                    } else if (formData.departNm === '11') {
                        const selectSoId = allMemos?.sonoCut?.find(item => item.ID === value);
                        const soId = selectSoId?.soId;
                        const memo = selectSoId?.ctMemo;
                        const data = {
                            soId: soId,
                            memo: memo
                        };
                        fetchCuttingContItems(data);
                        setFormData(prev => ({ ...prev, sono: soId }));
                    } else if (formData.departNm === '17') {
                        const selectsoid = allMemos?.sonoPress?.find(it => it.ID === value);
                        const soId = selectsoid?.soId;
                        const prMemo = selectsoid?.prMemo;
                        const data = {
                            soId,
                            prMemo
                        };
                        fetchPressingItems(data);
                        setFormData(prev => ({ ...prev, sono: soId }));
                        // console.log(selectsoid);
                    }

                }
                break;
            case 'departNm':
                if (value === '') {
                    setInfoData([]);
                }
                break;
            default:
                break;
        }
    };

    const handleQuantityChange = (index, value) => {
        // Ensure the value is a valid number and contains only digits (or is empty)
        if (value === '' || /^\d+$/.test(value)) {
            const numericValue = value === '' ? 0 : Number(value); // If empty, set to 0, otherwise convert to number

            // Default quantity (you may use a separate constant or reference to the default value)
            const defaultQuantity = infoData[index].rbqty;

            // Ensure the entered value is not greater than the default quantity
            const newQuantity = Math.min(numericValue, defaultQuantity);

            // // Update the rbqty state with the new quantity
            // const updatedRbqty = [...rbqty];
            // updatedRbqty[index] = newQuantity;
            // setRbqty(updatedRbqty);  // Update the state with new quantity


            const updatedInfoData = [...infoData];
            updatedInfoData[index].inwqty = newQuantity;  // Update inwqty with numeric value
            setInfoData(updatedInfoData);  // Update state with the new data


        }
    };

    // const handleColorChange = (index, value) => {
    //     // Update the rbqty state with the new quantity
    //     const updatedRbqty = [...color];
    //     updatedRbqty[index] = value;
    //     setColor(updatedRbqty);  // Update the state with new quantity
    // };


    const handleColorChange = (index, newColor) => {
        const updatedInfoData = [...infoData];
        updatedInfoData[index].color = newColor;  // Update color for the specific index
        setInfoData(updatedInfoData);  // Assuming `setInfoData` is your state setter function
    };



    const handleRadioChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
        setInfoData([]);
    };

    const tableContainerStyle = {
        marginTop: '1%',
        overflow: 'hidden',
        scrollbarWidth: 'none',
        msOverflowStyle: 'none',
    };

    const webkitScrollbarStyle = {
        overflowX: 'auto',
        overflowY: 'hidden',
        WebkitOverflowScrolling: 'touch',
    };

    function convertIntoOneObject(formData, infoData, rbqty, color) {
        var streId = 0;
        if (formData.streId !== '') {
            streId = formData.streId;
        } else if (formData.stchtopk !== '') {
            streId = formData.stchtopk
        }
        const department = departlist?.data?.length > 0 ? departlist.data.find((item) => item.ID === formData.departNm) : null;
        const departName = departlist && department !== null ? department.departNm : '0';

        const data = {
            dt: formData.dt,
            stkMemo: formData.stkMemo,
            departNm: departName,
            departId: formData.departNm,
            streId: streId,
            cutreId: formData.cutreId,
            empId: formData.empId,
            empNm: formData.empNm,
            itemId: formData.itemId,
            itemNm: formData.item,
            mcloth: formData.mcloth,
            m1cloth: formData.m1cloth,
            m2cloth: formData.m2cloth,
            m3cloth: formData.m3cloth,
            soId: formData.sono,
            userId: formData.userId,
            infoData: infoData,
            rbqty: rbqty,
            color: color,
            clothNm: formData.clothNm,
            model: formData.model,
            shadeNo: formData.shadeNo,
            icode: formData.icode,
            ordType: formData.ordType,
            locId: formData.locId,
            rackId: formData.rackId,
            prId: formData.prId
        };
        return data;
    };

    const departmentConfig = {
        '13': {
            label: 'Stitching Items',
            id: 'streId',
            options: allMemos?.stitchMemo || [],
            value: formData.streId,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'streId', value: newValue ? newValue.ID : '' } }, 'streId'),
            getOptionLabel: (option) => option.memo || '',  // Dynamically pass `getOptionLabel`
            isOptionEqualToValue: (option, value) => option.ID === value.ID,  // Dynamically pass `isOptionEqualToValue`
            valueFinder: (options, value) => options.find(item => item.ID === value) || null,  // Dynamically pass `valueFinder`
        },
        '11': {
            label: 'Cutting Items',
            id: 'cutreId',
            options: allMemos?.cutTopack || [],
            value: formData.cutreId,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'cutreId', value: newValue ? newValue.ID : '' } }, 'cutreId'),
            getOptionLabel: (option) => option.memo || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => options.find(item => item.ID === value) || null,
        },
        '12': {
            label: 'Stitching Items',
            id: 'stchtopk',
            options: allMemos?.stitchTopack || [],
            value: formData.stchtopk,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'stchtopk', value: newValue ? newValue.ID : '' } }, 'stchtopk'),
            getOptionLabel: (option) => option.stMemo || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => options.find(item => item.ID === value) || null,
        },
        '17': {
            label: 'Press Items',
            id: 'prId',
            options: allMemos?.pressMemo || [],
            value: formData.prId,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'prId', value: newValue ? newValue.ID : '' } }, 'prId'),
            getOptionLabel: (option) => option.memo || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => options.find(item => item.ID === value) || null,
        },
    };

    // Get the department's config based on formData.departNm
    const department = departmentConfig[formData.departNm];

    const dropdownlist = [
        {
            label: 'Department',
            id: 'departNm',
            options: filteredDepart || [],
            value: formData.departNm,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'departNm', value: newValue ? newValue.ID : '' } }, 'departNm'),
            getOptionLabel: (option) => option.departNm || '',  // Dynamically pass `getOptionLabel`
            isOptionEqualToValue: (option, value) => option.ID === value.ID,  // Dynamically pass `isOptionEqualToValue`
            valueFinder: (options, value) => options.find(item => item.ID === value) || null,  // Dynamically pass `valueFinder`
        }
    ];

    const dropdownSaleOrder = [
        {
            label: 'Sale Order',
            id: 'soId',
            options: [],
            value: formData.soId,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'soId', value: newValue ? newValue.ID : '' } }, 'soId'),
            getOptionLabel: (option) => option.sono || '',  // Dynamically pass `getOptionLabel`
            isOptionEqualToValue: (option, value) => option.ID === value,  // Dynamically pass `isOptionEqualToValue`
            valueFinder: (options, value) => options.find(item => item.ID === value.ID) || null,  // Dynamically pass `valueFinder`
        }
    ];

    const fields = [
        { label: 'Date', name: 'dt', type: 'date' },
    ];

    const fields2 = [
        { label: 'Stock Memo', name: 'stkMemo', type: 'readOnly' },
    ];


    const departmentConfig2 = {
        '13': {
            label: 'Sale Order',
            id: 'soId',
            options: allMemos?.sonoStitch || [],
            value: formData.soId,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'soId', value: newValue ? newValue.ID : '' } }, 'soId'),
            getOptionLabel: (option) => option.sono || '',  // Dynamically pass `getOptionLabel`
            isOptionEqualToValue: (option, value) => option.ID === value.ID,  // Dynamically pass `isOptionEqualToValue`
            valueFinder: (options, value) => options.find(item => item.ID === value) || null,  // Dynamically pass `valueFinder`
        },
        '11': {
            label: 'Sale Order',
            id: 'soId',
            options: allMemos?.sonoCut || [],
            value: formData.soId,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'soId', value: newValue ? newValue.ID : '' } }, 'soId'),
            getOptionLabel: (option) => option.sono || '',  // Dynamically pass `getOptionLabel`
            isOptionEqualToValue: (option, value) => option.ID === value.ID,  // Dynamically pass `isOptionEqualToValue`
            valueFinder: (options, value) => options.find(item => item.ID === value) || null,  // Dynamically pass `valueFinder`
        },
        '12': {
            label: 'Sale Order',
            id: 'soId',
            options: allMemos?.sonoStCont || [],
            value: formData.soId,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'soId', value: newValue ? newValue.ID : '' } }, 'soId'),
            getOptionLabel: (option) => option.sono || '',  // Dynamically pass `getOptionLabel`
            isOptionEqualToValue: (option, value) => option.ID === value.ID,  // Dynamically pass `isOptionEqualToValue`
            valueFinder: (options, value) => options.find(item => item.ID === value) || null,  // Dynamically pass `valueFinder`
        },
        '17': {
            label: 'Sale Order',
            id: 'soId',
            options: allMemos?.sonoPress || [],
            value: formData.soId,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'soId', value: newValue ? newValue.ID : '' } }, 'soId'),
            getOptionLabel: (option) => option.sono || '',  // Dynamically pass `getOptionLabel`
            isOptionEqualToValue: (option, value) => option.ID === value.ID,  // Dynamically pass `isOptionEqualToValue`
            valueFinder: (options, value) => options.find(item => item.ID === value) || null,  // Dynamically pass `valueFinder`
        },
    };

    const saleorderlist = departmentConfig2[formData.departNm];


    const departmentConfig3 = {
        '13': {
            label: 'Stitching Items',
            id: 'streId',
            options: itemlist || [],
            value: formData.streId,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'streId', value: newValue ? newValue.ID : '' } }, 'streId'),
            getOptionLabel: (option) => option.memo || '',  // Dynamically pass `getOptionLabel`
            isOptionEqualToValue: (option, value) => option.ID === value.ID,  // Dynamically pass `isOptionEqualToValue`
            valueFinder: (options, value) => options.find(item => item.ID === value) || null,  // Dynamically pass `valueFinder`
        },
        '11': {
            label: 'Cutting Items',
            id: 'cutreId',
            options: itemlist || [],
            value: formData.cutreId,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'cutreId', value: newValue ? newValue.ID : '' } }, 'cutreId'),
            getOptionLabel: (option) => option.memo || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => options.find(item => item.ID === value) || null,
        },
        '12': {
            label: 'Stitching Items',
            id: 'stchtopk',
            options: itemlist || [],
            value: formData.stchtopk,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'stchtopk', value: newValue ? newValue.ID : '' } }, 'stchtopk'),
            getOptionLabel: (option) => option.memo || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => options.find(item => item.ID === value) || null,
        },
        '17': {
            label: 'Press Items',
            id: 'prId',
            options: itemlist || [],
            value: formData.prId,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'prId', value: newValue ? newValue.ID : '' } }, 'prId'),
            getOptionLabel: (option) => option.memo || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => options.find(item => item.ID === value) || null,
        },
    };

    const SOitemslist = formData.soId !== '' && departmentConfig3[formData.departNm];

    const fetchPressingItems = async (id) => {
        const { soId, prMemo } = id;
        try {
            const res = await axios.get(`${baseUrl}?apicall=getPressingItemsBysono&soId=${soId}&prMemo=${prMemo}`);
            // console.log(res.data)
            setItemlist(res?.data?.data);
        } catch (error) {
            console.error('Error fetching info list:', error);
        }
    };

    const fetchStitchingItems = async (id) => {
        const { soId, memo, empType } = id;
        try {
            const response = await axios.get(`${baseUrl}?apicall=getStichingItems&soId=${soId}&memo=${memo}&empType=${empType}`);
            // console.log(response.data);
            setItemlist(response?.data?.data);
        } catch (error) {
            console.error('Error fetching info list:', error);
        }
    };

    const fetchCuttingContItems = async (id) => {
        const { soId, memo } = id;
        try {
            const response = await axios.get(`${baseUrl}?apicall=getCuttingContItems&soId=${soId}&memo=${memo}`);
            // console.log(response.data);
            setItemlist(response?.data?.data);
        } catch (error) {
            console.error('Error fetching info list:', error);
        }
    };

    const dropdownLocationRack = [
        {
            label: 'Location',
            id: 'locId',
            options: loclist?.data || [],
            value: formData.locId,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'locId', value: newValue ? newValue.locNm : '' } }, 'locId'),
            getOptionLabel: (option) => option.locNm || '',
            isOptionEqualToValue: (option, value) => option.locNm === value.locNm,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.locNm === value) || null;
                }
                return null;
            },
        },
        {
            label: 'Rack',
            id: 'rackId',
            options: racklist?.data || [],
            value: formData.rackId,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'rackId', value: newValue ? newValue.rackNm : '' } }, 'rackId'),
            getOptionLabel: (option) => option.rackNm || '',
            isOptionEqualToValue: (option, value) => option.rackNm === value.rackNm,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.rackNm === value) || null;
                }
                return null;
            },
        }
    ];

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const finalObject = convertIntoOneObject(formData, infoData, rbqty, color);
            // console.log(finalObject)

            const result = await dispatch(insertStockEntryProduction(finalObject)).unwrap();
            console.log('POST request successful!', result);
            alert("Stock Added");
            window.location.reload();

        } catch (error) {
            console.error('Error while making POST request:', error);
        } finally {
            setLoading(false);
        }

    };

    // console.log(itemlist)

    return (
        <>
            <TitleBar data={StockMenu} />
            <div style={{ margin: '1% 0.5%' }}>
                <h2>Stock Entry Production Wise</h2>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Paper style={{ padding: '2vh' }}>
                            <Grid container spacing={0.5}>

                                {fields?.map((field) => (
                                    <DateInputComponent
                                        key={field.name}
                                        formData={formData}
                                        handleDateChange={handleDateChange}
                                        handleInputChange={handleInputChange}
                                        styled={styled}
                                        inputStyles={inputStyles}
                                        isDesktop={isDesktop}
                                        field={field}
                                    />
                                ))}

                                <Grid item xs={12} md={6}>
                                    <Grid container alignItems="center" spacing={1} sx={{ mt: -1.5, mb: 0.5 }}>
                                        <Grid item style={isDesktop ? { width: '28%' } : { width: '100%' }}>
                                            <FormLabel component="legend">Order Type:</FormLabel>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl component="fieldset" fullWidth>
                                                <RadioGroup row name="ordType" value={formData.ordType} onChange={handleRadioChange}>
                                                    <FormControlLabel value="0" control={<Radio />} label="Manual" />
                                                    <FormControlLabel value="1" control={<Radio />} label="Sale Order" />
                                                </RadioGroup>
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Grid>

                                {fields2?.map((field) => (
                                    <DateInputComponent
                                        key={field.name}
                                        formData={formData}
                                        handleDateChange={handleDateChange}
                                        handleInputChange={handleInputChange}
                                        styled={styled}
                                        inputStyles={inputStyles}
                                        isDesktop={isDesktop}
                                        field={field}
                                    />
                                ))}


                                {
                                    dropdownlist && dropdownlist?.map((drop) => (
                                        <Dropdown
                                            key={drop.label}
                                            label={drop.label}
                                            id={drop.id}
                                            options={drop.options}
                                            value={drop.value}
                                            onChange={drop.onChange}
                                            isDesktop={isDesktop}
                                            getOptionLabel={drop.getOptionLabel}
                                            isOptionEqualToValue={drop.isOptionEqualToValue}
                                            valueFinder={drop.valueFinder}  // Pass `valueFinder` function here
                                        />
                                    ))
                                }

                                {/* {
                                    formData.ordType === '1' && dropdownSaleOrder.map((drop) => (
                                        <Dropdown
                                            key={drop.label}
                                            label={drop.label}
                                            id={drop.id}
                                            options={drop.options}
                                            value={drop.value}
                                            onChange={drop.onChange}
                                            isDesktop={isDesktop}
                                            getOptionLabel={drop.getOptionLabel}
                                            isOptionEqualToValue={drop.isOptionEqualToValue}
                                            valueFinder={drop.valueFinder}  // Pass `valueFinder` function here
                                        />
                                    ))
                                } */}

                                {
                                    formData.ordType === '1' && saleorderlist && (
                                        <Dropdown
                                            label={saleorderlist.label}
                                            id={saleorderlist.id}
                                            options={saleorderlist.options}
                                            value={saleorderlist.value}
                                            onChange={saleorderlist.onChange}
                                            isDesktop={isDesktop}
                                            getOptionLabel={saleorderlist.getOptionLabel}
                                            isOptionEqualToValue={saleorderlist.isOptionEqualToValue}
                                            valueFinder={saleorderlist.valueFinder}  // Pass `valueFinder` function here
                                        />
                                    )
                                }


                                {
                                    formData.ordType === '0' && department && (
                                        <Dropdown
                                            label={department.label}
                                            id={department.id}
                                            options={department.options}
                                            value={department.value}
                                            onChange={department.onChange}
                                            isDesktop={isDesktop}
                                            getOptionLabel={department.getOptionLabel}
                                            isOptionEqualToValue={department.isOptionEqualToValue}
                                            valueFinder={department.valueFinder}  // Pass `valueFinder` function here
                                        />
                                    )
                                }

                                {
                                    formData.ordType === '1' && SOitemslist && (
                                        <Dropdown
                                            label={SOitemslist.label}
                                            id={SOitemslist.id}
                                            options={SOitemslist.options}
                                            value={SOitemslist.value}
                                            onChange={SOitemslist.onChange}
                                            isDesktop={isDesktop}
                                            getOptionLabel={SOitemslist.getOptionLabel}
                                            isOptionEqualToValue={SOitemslist.isOptionEqualToValue}
                                            valueFinder={SOitemslist.valueFinder}  // Pass `valueFinder` function here
                                        />
                                    )
                                }

                                {
                                    dropdownLocationRack && dropdownLocationRack?.map((drop) => (
                                        <Dropdown
                                            key={drop.label}
                                            label={drop.label}
                                            id={drop.id}
                                            options={drop.options}
                                            value={drop.value}
                                            onChange={drop.onChange}
                                            isDesktop={isDesktop}
                                            getOptionLabel={drop.getOptionLabel}
                                            isOptionEqualToValue={drop.isOptionEqualToValue}
                                            valueFinder={drop.valueFinder}  // Pass `valueFinder` function here
                                        />
                                    ))
                                }

                                {Array.isArray(infoData) && infoData?.length > 0 &&
                                    <>
                                        <TableContainer style={{ ...tableContainerStyle, ...webkitScrollbarStyle }}>
                                            <Table style={isDesktop ? { width: '70%' } : { width: '100%' }}>
                                                <TableBody>

                                                    <TableRow>
                                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>Sr.No.</TableCell>
                                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>Barcode</TableCell>
                                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>Particulars</TableCell>
                                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>Color</TableCell>
                                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>Size</TableCell>
                                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>Qty</TableCell>
                                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>Damage Qty</TableCell>
                                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>Inw. Qty</TableCell>
                                                    </TableRow>
                                                    {
                                                        infoData?.map((item, index) => (
                                                            <TableRow key={index}>

                                                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' >{index + 1}</TableCell>
                                                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' >{item.barcode}</TableCell>
                                                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' >
                                                                    {
                                                                        formData.item && <>{formData.item}<br /></>
                                                                    }
                                                                    {
                                                                        formData.mcloth !== '0' && <>{formData.clothNm}<br /></>
                                                                    }
                                                                    {
                                                                        formData.m1cloth !== '0' && <>{formData.m1clothNm}<br /></>
                                                                    }
                                                                    {
                                                                        formData.m2cloth !== '0' && <>{formData.m2clothNm}<br /></>
                                                                    }
                                                                    {
                                                                        formData.m3cloth !== '0' && <>{formData.m3clothNm}<br /></>
                                                                    }
                                                                </TableCell>
                                                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' >
                                                                    <input type="text"
                                                                        value={item.color}  // Bind item.color here
                                                                        name='color'
                                                                        style={{ width: '100px', padding: '1px' }}
                                                                        onChange={(e) => handleColorChange(index, e.target.value)}
                                                                        placeholder='color'
                                                                    />
                                                                </TableCell>
                                                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' >{item.size}</TableCell>
                                                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' >{item.rbqty}</TableCell>
                                                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' >{item.dqty}</TableCell>
                                                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                                                                    <input
                                                                        type="text"
                                                                        value={item.inwqty}  // Bind item.inwqty here
                                                                        name="inwqty"
                                                                        style={{ width: '50px', padding: '1px' }}
                                                                        onChange={(e) => handleQuantityChange(index, e.target.value)}  // Handle input event for real-time validation
                                                                        placeholder='qty'
                                                                    />
                                                                </TableCell>
                                                            </TableRow>
                                                        ))
                                                    }
                                                </TableBody>
                                            </Table>
                                        </TableContainer>

                                    </>
                                }

                                <Grid item xs={12} textAlign="center">
                                    <Button variant="contained" color="primary" onClick={handleSubmit} disabled={loading === true}>
                                        {
                                            loading === true ?
                                                <><CircularProgress size="20px" /> wait...</> :
                                                "Submit"
                                        }
                                    </Button>
                                </Grid>

                            </Grid>
                            <ToastContainer />
                        </Paper>
                    </Grid>
                </Grid>
            </div>
        </>
    );
}

export default StkProdEntry2;
